import { render } from "./DynamicPage.vue?vue&type=template&id=3553523c"
import script from "./DynamicPage.vue?vue&type=script&lang=js"
export * from "./DynamicPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__